<div class="transaction-details-container">
  <div class="header">
    <span>Manage and monitor your domains. Track SSL certificates, subdomains, and certificate expiry status for all your added domains.</span>
    <div class="actions">
      <button type="button" class="filter-button" (click)="addNew()">
        <i class="fa-solid fa-plus" style="margin-right: 8px;"></i>
        <span>Add New</span>
      </button>
    </div>
  </div>

  <div class="table-container">
    <div *ngIf="isLoading" class="no-transactions-message">Loading domains...</div>

    <table *ngIf="!isLoading" class="transactions-table">
      <thead>
        <tr>
          <th>
            <div class="th-content">
              <i class="fa-solid fa-globe th-icon"></i>
              <span>Domain</span>
            </div>
          </th>
          <th>
            <div class="th-content">
              <i class="fa-solid fa-calendar-days th-icon"></i>
              <span>Added On</span>
            </div>
          </th>
          <th>
            <div class="th-content">
              <i class="fa-solid fa-gears th-icon"></i>
              <span>Actions</span>
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngIf="domains.length > 0; else noDomains">
          <tr *ngFor="let item of domains" class="clickable-row" (click)="viewSubDomains(item.domain || item.name)">
            <td style="font-weight: 500;">
              <i class="fa-solid fa-globe" style="color: #289dd2; margin-right: 8px; font-size: 13px;"></i>
              {{ item.domain || item.name }}
            </td>
            <td style="opacity: 0.9; font-size: 14px;">
              {{ (item.created_at || item.createdAt) | date: 'MMM dd, yyyy' }}
            </td>
            <td>
              <button class="action-button" (click)="$event.stopPropagation(); viewSubDomains(item.domain || item.name)">
                <i class="fa-solid fa-eye" style="margin-right: 5px;"></i>
                View Subdomains
              </button>
            </td>
          </tr>
        </ng-container>
        <ng-template #noDomains>
          <tr>
            <td colspan="3" class="no-transactions-message">{{ noDomainsMessage }}</td>
          </tr>
        </ng-template>
      </tbody>
    </table>
  </div>
</div>
